module.exports = __webpack_public_path__ + "static/media/logo.bf05a248.svg";